/**
 * Decoder Hook
 * Provides utility functions for opening decoder with text
 */

import { useCallback } from 'react';
import { useDecoderStore } from '../store/decoder-store';
import { useBottomPanelStore } from '../store/bottomPanelStore';

export function useDecoder() {
  const setInitialInput = useDecoderStore((state) => state.setInitialInput);
  const setBottomPanelTab = useBottomPanelStore((state) => state.setTab);
  const openBottomPanel = useBottomPanelStore((state) => state.open);

  const openDecoderWith = useCallback(
    (text: string) => {
      // Set the text in decoder
      setInitialInput(text);

      // Switch to decoder tab (this automatically opens the bottom panel)
      setBottomPanelTab('decoder');
    },
    [setInitialInput, setBottomPanelTab],
  );

  const openDecoder = useCallback(() => {
    setBottomPanelTab('decoder');
    openBottomPanel();
  }, [setBottomPanelTab, openBottomPanel]);

  return {
    openDecoderWith,
    openDecoder,
  };
}
